import React, { Component } from 'react'
import { connect } from 'react-redux'
import VisibilitySensor from 'react-visibility-sensor'
import Title from '../components/Title.jsx'
import Button from '../components/Button.jsx'
import SideImage from '../components/SideImage.jsx'
import AnimatedCounter from '../components/AnimatedCounter.jsx'

class PoolInfoContainer extends Component {
    state = {
        startAnimation: false
    }

    componentWillUnmount() {
        this.removeInterval()
    }

    removeInterval = () => {
        clearInterval(this.interval)
    }

    onVisibilityChange = (isVisible) => {
        if (isVisible) {
            this.setState({
                startAnimation: true
            })
        }
    }

    render() {
        return (
            <div className="pool-info-container section-spacing">
                <div className="pool-info-container__sideimage hidden-sm hidden-xs">
                    <SideImage
                        backgroundImage="/images/bck/bed_servicesleft.jpg"
                        foregroundImage="/images/el/bed_pool.png"
                    />
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <Title
                            className={'header1--center'}
                            title={this.props.langData.title}
                        />
                        <div className="col-md-6">
                            <div className="pool-info-container__relativeimage visible-sm visible-xs">
                                <SideImage
                                    backgroundImage="/images/bck/bed_servicesleft.jpg"
                                    foregroundImage="/images/el/bed_pool.png"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="pool-info-inner">
                                <div className="pool-info-text">
                                    <h2 className="pool-info-text__subtitle">
                                        {this.props.langData.subtitle}
                                    </h2>
                                    <p className="paragraph">
                                        {this.props.langData.text}
                                    </p>
                                </div>
                                <div className="pool-info-anim">
                                    <VisibilitySensor
                                        onChange={this.onVisibilityChange}
                                        active={!this.state.startAnimation}
                                    />
                                    <div className="pool-info-anim-box pool-info-anim-box--bordered">
                                        <img
                                            className="pool-info-anim-box__img"
                                            src="/images/ico/bed_clock.png"
                                        />
                                        <div className="pool-info-anim-box-inner">
                                            <AnimatedCounter
                                                endNumber={70}
                                                startAnimation={this.state.startAnimation}
                                                transitionDuration={2}
                                                prefix={'+'}
                                                sufix={'%'}
                                            />
                                            <p className="pool-info-anim-box-inner__text">
                                                {this.props.langData.speed}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="pool-info-anim-box">
                                        <img
                                            className="pool-info-anim-box__img"
                                            src="/images/ico/bed_money.png"
                                        />
                                        <div className="pool-info-anim-box-inner">
                                            <AnimatedCounter
                                                endNumber={30}
                                                startAnimation={this.state.startAnimation}
                                                transitionDuration={2}
                                                prefix={'-'}
                                                sufix={'%'}
                                            />
                                            <p className="pool-info-anim-box-inner__text">
                                                {this.props.langData.price}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="pool-info-button">
                                    <Button
                                        type={'yellow'}
                                        text={this.props.langData.buttonText}
                                        link="/usluge#izgradnjabazena"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => ({
    langData: state.langData.landing.poolInfo
})

export default connect(mapStateToProps)(PoolInfoContainer)



// WEBPACK FOOTER //
// ./src/scripts/containers/PoolInfoContainer.jsx